import { combineReducers } from 'redux-immutablejs';
import Immutable from 'immutable';

import {
    createFormReducer,
    createValidationReducer,
    createResultsReducer,
    createFieldSetVisibilityReducer,
    createQuoteConfigReducer,
    callCentreTimes,
    createContentReducer,
    createPrefillVerifyReducer
} from 'ctm-vertical-base';
import { createApiResponsesReducer } from './reducers/apiResponses';
import { createAuthUserReducer } from './reducers/auth_user';
import { formReducerCases } from './reducers/form';
import { validationReducerCases } from './reducers/validation';
import { models } from './models';

// Setup initial state for results
const resultsState = Immutable.Map({
    config: Immutable.Map({
        quoteDescriptor: false,
        pageNumber: 1,
        displayMode: null,
        previousDisplayMode: null,
        filterDisplayMode: null,
        featuresModeAccordionOpenState: Immutable.Map(),
        sorting: Immutable.Map({
            sortBy: 'productMeta.price.annualPremium',
            sortDir: 'asc',
            sortType: 'numeric'
        }),
        // Add new multi-level sorting config
        multiLevelSorting: Immutable.Map({
            sortCriteria: Immutable.List([
                Immutable.Map({
                    field: 'productMeta.price.annualPremium',
                    dir: 'asc',
                    type: 'numeric'
                }),
                Immutable.Map({
                    field: 'productMeta.excess',
                    dir: 'asc',
                    type: 'numeric'
                }),
                Immutable.Map({
                    field: 'providerMeta.name',
                    dir: 'asc',
                    type: 'alpha'
                })
            ])
        }),
        filters: Immutable.Map({
            frequency: 'annual',
            available: true, // if the products have the available: true
            initialised: {},
            fetchNewResults: false,
            currentFilterActions: []
        })
    }),
    payload: Immutable.Map({ resultsMeta: Immutable.Map() }),
    productInfo: Immutable.Map()
});

const callCentreTimesReducer = () => {
    return Immutable.Map({
        times: callCentreTimes
    });
};

const quotePath = 'vertical.quote';
const callMeBackPath = 'vertical.callMeBack';

// Combine and export all reducers into one root reducer for the vertical
export default combineReducers({
    quote: combineReducers({
        config: createQuoteConfigReducer(),
        form: createFormReducer(models.formSchemaModel.formStateModel(quotePath), quotePath, formReducerCases),
        validation: createValidationReducer(models.validationModel.stateModel(quotePath), models.validationModel, quotePath, validationReducerCases),
        visibility: createFieldSetVisibilityReducer(models.formSchemaModel.visibilityStateModel(quotePath), quotePath),
        results: createResultsReducer(resultsState),
        apiResponses: createApiResponsesReducer(),
        authUser: createAuthUserReducer(),
        prefillVerify: createPrefillVerifyReducer()
    }),
    callMeBack: combineReducers({
        form: createFormReducer(models.formSchemaModel.formStateModel(callMeBackPath), callMeBackPath),
        validation: createValidationReducer(models.validationModel.stateModel(callMeBackPath), models.validationModel, callMeBackPath),
        visibility: createFieldSetVisibilityReducer(models.formSchemaModel.visibilityStateModel(callMeBackPath), callMeBackPath)
    }),
    callCentreHours: callCentreTimesReducer,
    content: createContentReducer()
});
